<template>
    <el-card class="upload">
        <el-steps
            :active="step"
            finish-status="success"
            simple
            class="mb-8">
            <el-step
                :title="$t('Other.Upload.download_template')"
                icon="el-icon-download" />
            <el-step
                :title="$t('Other.Upload.deal_data')"
                icon="el-icon-setting" />
            <el-step
                :title="$t('Other.Upload.upload_files')"
                icon="el-icon-upload2" />
        </el-steps>

        <div v-if="step === 0">
            <div class="flex items-start justify-between">
                <div>
                    <h4>{{ $t('Other.Upload.firststep') }}：{{ $t('Other.Upload.download_template') }}</h4>
                    <p>1、{{ $t('Other.Upload.please_click') }}。</p>
                    <p class="mb-0">2、{{ $t('Other.Upload.tolead_info') }}（<span class="upload-tips-red">{{ $t('Other.Upload.red_info') }}</span>{{ $t('Other.Upload.required_fields') }}）</p>
                </div>
                <el-button type="success" @click="downloadTemplate()">{{ $t('Other.Upload.download_template') }}</el-button>
            </div>
            <img
                v-if="[1, 2].includes(form.type)"
                src="../assets/images/member_temp.png"
                class="w-full mb-8">
            <img
                v-if="form.type === 3"
                src="../assets/images/contract_temp.png"
                class="w-full mb-8">
            <img
                v-if="form.type === 4"
                src="../assets/images/contract_coach_temp.png"
                class="w-full mb-8">
            <img
                v-if="form.type === 5"
                src="../assets/images/contract_cabinet_temp.png"
                class="w-full mb-8">
            <img
                v-if="form.type === 6"
                src="../assets/images/contract_cz_card_temp.png"
                class="w-full mb-8">
            <img
                v-if="form.type === 7"
                src="../assets/images/contract_prepay_temp.png"
                class="w-full mb-8">
            <h4>{{ $t('Other.Upload.announcements') }}：</h4>
            <!-- 会员 -->
            <div v-if="isMember === 'member'">
                <p>1、<span class="upload-tips-red">{{ $t('Card.client_name') }}</span>：{{ $t('Other.Upload.client_realname') }}</p>
                <p>2、<span class="upload-tips-red">{{ $t('Common.gender') }}</span>：{{ $t('Other.Upload.man_or_wom') }}</p>
                <p>3、<span class="upload-tips-red">{{ $t('Common.phone_number') }}</span>：{{ $t('Other.Upload.eleven') }}（{{ $t('Other.Upload.such_as') }}：18589091045）</p>
                <p>4、<span class="upload-tips-red">{{ $t('Client.Add.status') }}</span>：{{ $t('Reception.Fifth.normal') }}/{{ $t('Lesson.deleted') }} （{{ $t('Other.Upload.deleted_user_not_allowed') }}）</p>
                <p>5、<span class="upload-tips-red">{{ $t('Other.Upload.followup_sales') }}</span>：{{ $t('Other.Upload.followup_sales_niname') }}（{{ $t('Other.Upload.niname_inlist') }}）</p>
                <p>6、{{ $t('Common.follow_coach') }}：{{ $t('Other.Upload.flowup_coach_nickname') }}（{{ $t('Other.Upload.coach_inlist') }}）</p>
                <p>7、{{ $t('Other.Upload.Member_card') }}：{{ $t('Other.Upload.Member_number') }}（{{ $t('Other.Upload.ifyou_holdmembership') }}）</p>
                <p>8、{{ $t('Member.open_card_store') }}（{{ $t('Other.Upload.ust_import_cardshop') }}）：{{ $t('Other.Upload.member_card_shop') }}</p>
                <p>9、{{ $t('Common.birthday') }}：{{ $t('Other.Upload.year4mon2day2') }}（{{ $t('Other.Upload.such_as') }}：19901117 {{ $t('Other.Upload.or') }} 1990-11-17）</p>
                <p>10、<span class="upload-tips-red">{{ $t('Client.Add.get_attributes') }}</span>：{{ $t('Other.Upload.some_other') }}</p>
                <p>11、<span class="upload-tips-red">{{ $t('Client.Add.attributes') }}</span>：{{ $t('Other.Upload.manpower_ohter') }}</p>
                <p>12、{{ $t('Client.Add.certificate_type') }}：{{ $t('Other.Upload.Various_syndromes') }}</p>
                <p>13、{{ $t('Client.Add.certificate_number') }}：{{ $t('Other.Upload.import_ID_Number') }}</p>
                <p>14、{{ $t('Common.remark') }}：{{ $t('Other.Upload.Non_essential_items') }}</p>
            </div>
            <div v-if="form.type === 3">
                <p>1、<span class="upload-tips-red">{{ $t('Contract.number') }}</span>：{{ $t('Other.Upload.Membership_number') }}</p>
                <p>2、<span class="upload-tips-red">{{ $t('Member.name2') }}</span>：{{ $t('Member.name2') }}</p>
                <p>3、<span class="upload-tips-red">{{ $t('Common.telephone_number') }}</span>：{{ $t('Other.Upload.11_phone_number') }}（{{ $t('Other.Upload.such_as') }}：18589091043）</p>
                <p>4、<span class="upload-tips-red">{{ $t('Contract.card_name') }}</span>：{{ $t('Other.Upload.SystemSetting') }}</p>
                <p>5、{{ $t('Other.Upload.buys_num') }}：{{ $t('Number_of_purchases') }}</p>
                <p>6、{{ $t('Other.Upload.Remainingtimes') }}：{{ $t('Other.Upload.ResidualCard') }}</p>
                <p>7、<span class="upload-tips-red">{{ $t('Contract.type') }}</span>：{{ $t('Other.Upload.remark_transaction') }}</p>
                <p>8、{{ $t('Other.Upload.Original_cont_number') }}：{{ $t('Other.Upload.Write_the_original') }}</p>
                <p>9、<span class="upload-tips-red">{{ $t('Contract.status') }}</span>：{{ $t('Other.Upload.Isit_effective') }}</p>
                <p>10、<span class="upload-tips-red">{{ $t('Sell.standard_amount') }}</span>：{{ $t('Other.Upload.originalprice') }}</p>
                <p>11、<span class="upload-tips-red">{{ $t('Charge.amount_receivable') }}</span>：{{ $t('Other.Upload.The_amount_becharged') }}</p>
                <p>12、<span class="upload-tips-red">{{ $t('Sell.Charge.paid_amount') }}</span>：{{ $t('Other.Upload.The_actual_amount') }}</p>
                <p>13、<span class="upload-tips-red">{{ $t('Sell.Pay.title') }}</span>：{{ $t('Other.Upload.Transfer_accounts') }}</p>
                <p>14、<span class="upload-tips-red">{{ $t('Sell.sign_date') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}，{{ $t('Other.Upload.if_any_import') }}（{{ $t('Other.Upload.such_as') }}：19901117 12:20:00 {{ $t('Other.Upload.or') }} 1990-11-17 12:20:00 {{ $t('Other.Upload.or') }} 19901117 {{ $t('Other.Upload.or') }} 1990-11-17）</p>
                <p>15、<span class="upload-tips-red">{{ $t('Member.open_card_method') }}</span>：{{ $t('Other.Upload.Open_card_day') }}</p>
                <p>16、<span class="upload-tips-red">{{ $t('Contract.start_time') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}（{{ $t('Other.Upload.such_as') }}：19901117 {{ $t('Other.Upload.or') }} 1990-11-17）{{ $t('Other.Upload.the_daycard_mustwrite') }}</p>
                <p>17、<span class="upload-tips-red">{{ $t('Contract.end_time') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}（{{ $t('Other.Upload.such_as') }}：19901117 {{ $t('Other.Upload.or') }} 1990-11-17）{{ $t('Other.Upload.buycard_indate') }}</p>
                <p>18、{{ $t('Other.Upload.Days_of_validity') }}</p>
                <p>19、<span class="upload-tips-red">{{ $t('Member.saler') }}</span>：{{ $t('Other.Upload.salesperson_niname') }}</p>
                <p>20、<span class="upload-tips-red">{{ $t('Member.sign_store') }}</span>：{{ $t('Other.Upload.Shops_that_open') }}</p>
                <p>21、<span class="upload-tips-red">{{ $t('Contract.support_store') }}</span>：{{ $t('Other.Upload.Shops_supported') }}</p>
                <p>22、{{ $t('Common.remark') }}：{{ $t('Other.Upload.Non_essential_items') }}</p>
            </div>
            <div v-if="form.type === 4">
                <p>1、<span class="upload-tips-red">{{ $t('Contract.number') }}</span>：{{ $t('Other.Upload.PrivateEducation_num') }}</p>
                <p>2、<span class="upload-tips-red">{{ $t('Member.name2') }}</span>：{{ $t('Member.name2') }}</p>
                <p>3、<span class="upload-tips-red">{{ $t('Common.telephone_number') }}</span>：{{ $t('Other.Upload.11_phone_number') }}（{{ $t('Other.Upload.such_as') }}：18589091043）</p>
                <p>4、<span class="upload-tips-red">{{ $t('Course.name') }}</span>：{{ $t('Other.Upload.CourseSetup') }}</p>
                <p>5、{{ $t('Other.Upload.level_of_courses') }}：{{ $t('Other.Upload.personlevel') }}</p>
                <p>6、{{ $t('Other.Upload.importclassnum') }}：{{ $t('Other.Upload.Number_of_courses') }}</p>
                <p>7、{{ $t('Other.Upload.current_remaining') }}</p>
                <p>8、<span class="upload-tips-red">{{ $t('Other.Upload.ContractType') }}</span>：{{ $t('Other.Upload.other_formalities_eg') }}</p>
                <p>9、{{ $t('Other.Upload.Original_cont_number') }}：{{ $t('Other.Upload.Write_the_original') }}</p>
                <p>10、<span class="upload-tips-red">{{ $t('Contract.status') }}</span>：{{ $t('Other.Upload.Isit_effective') }}</p>
                <p>11、<span class="upload-tips-red">{{ $t('Sell.standard_amount') }}</span>：{{ $t('Other.Upload.originalprice') }}</p>
                <p>12、<span class="upload-tips-red">{{ $t('Charge.amount_receivable') }}</span>：{{ $t('Other.Upload.The_amount_becharged') }}</p>
                <p>13、<span class="upload-tips-red">{{ $t('Sell.Charge.paid_amount') }}</span>：{{ $t('Other.Upload.The_actual_amount') }}</p>
                <p>14、<span class="upload-tips-red">{{ $t('Sell.Pay.title') }}</span>：{{ $t('Other.Upload.Transfer_accounts') }}</p>
                <p>15、<span class="upload-tips-red">{{ $t('Sell.sign_date') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}，{{ $t('Other.Upload.if_any_import') }}（{{ $t('Other.Upload.such_as') }}：19901117 12:20:00 或 1990-11-17 12:20:00 或 19901117 或 1990-11-17）</p>
                <p>16、<span class="upload-tips-red">{{ $t('Contract.start_time') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}（{{ $t('Other.Upload.such_as') }}：19901117 {{ $t('Other.Upload.or') }} 1990-11-17）</p>
                <p>17、<span class="upload-tips-red">{{ $t('Contract.end_time') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}（{{ $t('Other.Upload.such_as') }}：19901117 {{ $t('Other.Upload.or') }} 1990-11-17）（若此合同已被转让，请填写合同被转让日期）</p>
                <p>18、<span class="upload-tips-red">{{ $t('Member.saler') }}</span>：{{ $t('Other.Upload.salesperson_niname') }}</p>
                <p>19、<span class="upload-tips-red">{{ $t('Course.coach') }}</span>：{{ $t('Other.Upload.write_niname') }}</p>
                <p>20、<span class="upload-tips-red">{{ $t('Member.sign_store') }}</span>：{{ $t('Other.Upload.write_shop') }}</p>
                <p>21、{{ $t('Common.remark') }}：{{ $t('Other.Upload.Non_essential_items') }}</p>
            </div>
            <div v-if="form.type === 5">
                <p>1、<span class="upload-tips-red">{{ $t('Contract.number') }}</span>：{{ $t('Other.Upload.Lease_cabi_cont_num') }}</p>
                <p>2、<span class="upload-tips-red">{{ $t('Member.name2') }}</span>：{{ $t('Member.name2') }}</p>
                <p>3、<span class="upload-tips-red">{{ $t('Common.telephone_number') }}</span>：{{ $t('Other.Upload.11_phone_number') }}（{{ $t('Other.Upload.such_as') }}：18589091043）</p>
                <p>4、<span class="upload-tips-red">{{ $t('Common.cabinet_number') }}</span>：{{ $t('Other.Upload.initials+lease') }}</p>
                <p>5、<span class="upload-tips-red">{{ $t('Week.lease_period2') }}</span>: {{ $t('Other.Upload.leaseperiod') }}）</p>
                <p>6、<span class="upload-tips-red">{{ $t('Other.Upload.Fillin_ContractType') }}</span>：{{ $t('Other.Upload.longinfo') }}</p>
                <p>7、{{ $t('Other.Upload.Original_cont_number') }}：{{ $t('Other.Upload.Write_the_original') }}</p>
                <p>8、<span class="upload-tips-red">{{ $t('Contract.status') }}</span>：{{ $t('Other.Upload.somepact') }}</p>
                <p>9、<span class="upload-tips-red">{{ $t('Sell.standard_amount') }}</span>：{{ $t('Other.Upload.originalprice') }}</p>
                <p>10、<span class="upload-tips-red">{{ $t('Charge.amount_receivable') }}</span>：{{ $t('Other.Upload.The_amount_becharged') }}</p>
                <p>11、<span class="upload-tips-red">{{ $t('Sell.Charge.paid_amount') }}</span>：{{ $t('Other.Upload.The_actual_amount') }}</p>
                <p>12、<span class="upload-tips-red">{{ $t('Sell.Pay.title') }}</span>：{{ $t('Other.Upload.Transfer_accounts') }}</p>
                <p>13、<span class="upload-tips-red">{{ $t('Sell.sign_date') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}，{{ $t('Other.Upload.if_any_import') }}（{{ $t('Other.Upload.such_as') }}：19901117 12:20:00 或 1990-11-17 12:20:00 或 19901117 或 1990-11-17）</p>
                <p>14、<span class="upload-tips-red">{{ $t('Contract.start_time') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}（{{ $t('Other.Upload.such_as') }}：19901117 {{ $t('Other.Upload.or') }} 1990-11-17）</p>
                <p>15、<span class="upload-tips-red">{{ $t('Contract.end_time') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}（{{ $t('Other.Upload.such_as') }}：19901117 {{ $t('Other.Upload.or') }} 1990-11-17）（若此合同已被转让，请填写合同被转让日期）</p>
                <p>16、<span class="upload-tips-red">{{ $t('Member.saler') }}</span>：{{ $t('Other.Upload.salesperson_niname') }}</p>
                <p>17、<span class="upload-tips-red">{{ $t('Member.sign_store') }}</span>：{{ $t('Other.Upload.cabinet_located') }}</p>
                <p>18、{{ $t('Common.remark') }}：{{ $t('Other.Upload.Non_essential_items') }}</p>
            </div>
            <div v-if="form.type === 6">
                <p>1、<span class="upload-tips-red">{{ $t('Contract.number') }}</span>：{{ $t('Other.Upload.StorageCard') }}</p>
                <p>2、<span class="upload-tips-red">{{ $t('Member.name2') }}</span>：{{ $t('Member.name2') }}</p>
                <p>3、<span class="upload-tips-red">{{ $t('Common.telephone_number') }}</span>：{{ $t('Other.Upload.11_phone_number') }}（{{ $t('Other.Upload.such_as') }}：18589091043）</p>
                <p>4、<span class="upload-tips-red">{{ $t('Other.Upload.CardName') }}</span>：{{ $t('Other.Upload.SystemCardName') }}</p>
                <p>5、<span class="upload-tips-red">{{ $t('Other.Upload.storage_value') }}</span>：{{ $t('Other.Upload.buy_at_time_mon') }}</p>
                <p>6、<span class="upload-tips-red">{{ $t('Sell.Charge.current_balance') }}</span>：{{ $t('Other.Upload.remaining_amount') }}</p>
                <p>7、<span class="upload-tips-red">{{ $t('Contract.type') }}</span>：{{ $t('Other.Upload.longinfo') }}</p>
                <p>8、{{ $t('Other.Upload.Original_cont_number') }}：{{ $t('Other.Upload.Write_the_original') }}</p>
                <p>9、<span class="upload-tips-red">{{ $t('Contract.status') }}</span>：{{ $t('Other.Upload.Isit_effective') }}</p>
                <p>10、<span class="upload-tips-red">{{ $t('Sell.standard_amount') }}</span>：{{ $t('Other.Upload.originalprice') }}</p>
                <p>11、<span class="upload-tips-red">{{ $t('Charge.amount_receivable') }}</span>：{{ $t('Other.Upload.The_amount_becharged') }}</p>
                <p>12、<span class="upload-tips-red">{{ $t('Sell.Charge.paid_amount') }}</span>：{{ $t('Other.Upload.The_actual_amount') }}</p>
                <p>13、<span class="upload-tips-red">{{ $t('Sell.Pay.title') }}</span>：{{ $t('Other.Upload.Transfer_accounts') }}</p>
                <p>14、<span class="upload-tips-red">{{ $t('Sell.sign_date') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}，{{ $t('Other.Upload.if_any_import') }}（{{ $t('Other.Upload.such_as') }}：19901117 12:20:00 或 1990-11-17 12:20:00 或 19901117 或 1990-11-17）</p>
                <p>15、<span class="upload-tips-red">{{ $t('Member.open_card_method') }}</span>：{{ $t('Other.Upload.theday_buy') }}</p>
                <p>16、<span class="upload-tips-red">{{ $t('Contract.start_time') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}（{{ $t('Other.Upload.such_as') }}：19901117 {{ $t('Other.Upload.or') }} 1990-11-17）{{ $t('Other.Upload.the_daycard_mustwrite') }}</p>
                <p>17、<span class="upload-tips-red">{{ $t('Contract.end_time') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}（{{ $t('Other.Upload.such_as') }}：19901117 {{ $t('Other.Upload.or') }} 1990-11-17）{{ $t('Other.Upload.buycard_indate') }}</p>
                <p>18、{{ $t('Other.Upload.Days_of_validity') }}</p>
                <p>19、<span class="upload-tips-red">{{ $t('Member.saler') }}</span>：{{ $t('Other.Upload.salesperson_niname') }}</p>
                <p>20、<span class="upload-tips-red">{{ $t('Member.sign_store') }}</span>：{{ $t('Other.Upload.Shops_that_open') }}</p>
                <p>21、<span class="upload-tips-red">{{ $t('Contract.support_store') }}</span>：{{ $t('Other.Upload.Shops_supported') }}</p>
                <p>22、{{ $t('Common.remark') }}：{{ $t('Other.Upload.Non_essential_items') }}</p>
            </div>
            <div v-if="form.type === 7">
                <p>1、<span class="upload-tips-red">{{ $t('Sell.charge_date') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}（{{ $t('Other.Upload.such_as') }}：19901117 {{ $t('Other.Upload.or') }} 1990-11-17）</p>
                <p>2、<span class="upload-tips-red">{{ $t('Member.name2') }}</span>：{{ $t('Member.name2') }}</p>
                <p>3、<span class="upload-tips-red">{{ $t('Common.telephone_number') }}</span>：{{ $t('Other.Upload.11_phone_number') }}（{{ $t('Other.Upload.such_as') }}：18589091043）</p>
                <p>4、<span class="upload-tips-red">{{ $t('Charge.deposit_amount') }}</span>：{{ $t('Other.Upload.Actual_amountcharged') }}</p>
                <p>5、<span class="upload-tips-red">{{ $t('Sell.Pay.title') }}</span>：{{ $t('Other.Upload.Transfer_accounts') }}</p>
                <p>6、<span class="upload-tips-red">{{ $t('Member.saler2') }}</span>：{{ $t('Other.Upload.salesperson_niname') }}</p>
                <p>7、<span class="upload-tips-red">{{ $t('Charge.expiration_date') }}</span>：{{ $t('Other.Upload.year4mon2day2') }}（{{ $t('Other.Upload.such_as') }}：19901117 {{ $t('Other.Upload.or') }} 1990-11-17）</p>
                <p>8、{{ $t('Common.remark') }}：{{ $t('Other.Upload.Non_essential_items') }}</p>
                <p>9、<span class="upload-tips-red">{{ $t('Member.sign_store') }}</span>：{{ $t('Other.Upload.handle_cliet_card') }}</p>
            </div>
        </div>
        <div v-else-if="step === 1">
            <h4>{{ $t('Other.Upload.second_step') }}：{{ $t('Other.Upload.Choos_way') }}</h4>
            <ul class="import-types flex items-center justify-center">
                <li :class="{'active': active === 1}" v-if="operations.includes('INSERT_ON_DUPLICATE_OVERRIDE')">
                    <i @click="active = 1"></i>
                    <p><b>{{ $t('Other.Upload.import_new_data') }}</b><br>{{ $t('Other.Upload.New_additions') }}<br>{{ $t('Other.Upload.updates_for_duplicate_data') }}</p>
                </li>
                <li :class="{'active': active === 2}" v-if="operations.includes('INSERT_ON_DUPLICATE_IGNORE')">
                    <i @click="active = 2"></i>
                    <p><b>{{ $t('Other.Upload.only_import') }}</b><br>{{ $t('Other.Upload.New_additions') }}<br>{{ $t('Other.Upload.recoverdata') }}</p>
                </li>
                <li :class="{'active': active === 3}"  v-if="operations.includes('INSERT_IGNORE_ON_DUPLICATE_UPDATE')">
                    <i @click="active = 3"></i>
                    <p><b>{{ $t('Other.Upload.dont_import') }}</b><br>{{ $t('Other.Upload.new_data_import') }}<br>{{ $t('Other.Upload.only_new_recinfo') }}</p>
                </li>
            </ul>
            <div v-if="isMember === 'member'" class="text-center mb-10">
                <el-checkbox v-model="form.autoFixPhone">{{ $t('Other.Upload.importeleven') }}</el-checkbox>
            </div>
        </div>
        <div v-else>
            <h4>{{ $t('Other.Upload.thri_step') }}：{{ $t('Other.Upload.pleafileupload') }}</h4>
            <drag-upload v-model="form.file" />
        </div>

        <div class="text-center">
            <el-button
                v-if="step > 0"
                type="info"
                @click="step--">
                {{ $t('Common.prev_step') }}
            </el-button>
            <el-button
                v-if="step < 2"
                type="primary"
                @click="next">
                {{ $t('Common.next_step') }}
            </el-button>
            <el-button
                @click="uploadFile"
                v-if="step === 2"
                type="primary">
                {{ $t('Other.Upload.UploadImport') }}
            </el-button>
        </div>
    </el-card>
</template>

<script>
import { Steps, Step } from 'element-ui';
import DragUpload from '@/components/widget/DragUpload';

export default {
    name: 'Upload',
    components: {
        ElSteps: Steps,
        ElStep: Step,
        DragUpload,
    },
    data() {
        return {
            step: 0,
            active: null,  // 1-INSERT_ON_DUPLICATE_OVERRIDE 2-INSERT_ON_DUPLICATE_IGNORE 3-INSERT_IGNORE_ON_DUPLICATE_UPDATE
            form: {
                autoFixPhone: false,
                file: null,
                operation: null,
                type: Number(this.$route.query.type),  // 1-潜在客户,2-会员导入,3-会籍合同,4-私教合同,5-租赁柜合同,6-储值卡合同,7-定金合同
            },
            isMember: this.$route.query.isMember,
            template: null,
            showImg: 'member_temp',
            operations: [],
        };
    },
    created() {
        this.fetchTemplate();
        this.fetchType();
    },
    methods: {
        next() {
            if (this.step === 1 && !this.active) return $ele.$message.warning(this.$t('Other.Upload.choose_data_process_way'));
            this.step++;
        },
        fetchTemplate() {
            API.get('constant/excel-template').then(res => {
                this.template = res;
            });
        },
        // 下载模板
        downloadTemplate() {
            if (this.isMember === 'member') window.location.href = this.template.client;
            else if (this.form.type === 3) window.location.href = this.template.contractMshp;
            else if (this.form.type === 4) window.location.href = this.template.contractCoach;
            else if (this.form.type === 5) window.location.href = this.template.contractLocker;
            else if (this.form.type === 6) window.location.href = this.template.contractCZCard;
            else if (this.form.type === 7) window.location.href = this.template.contractPrepay;
        },
        fetchType() {
            API.get(`import/operation?type=${this.form.type}`)
            .then(res => {
                this.operations = res.operations;
            });
        },
        // 上传
        uploadFile() {
            // 操作类型
            this.form.operation = this.active === 1 ? 'INSERT_ON_DUPLICATE_OVERRIDE'
                : this.active === 2 ? 'INSERT_ON_DUPLICATE_IGNORE' : 'INSERT_IGNORE_ON_DUPLICATE_UPDATE';
            // const form = Object.assign({}, this.form);
            // formdata 数据
            let filename = (new Date()).getTime() + '.xlsx';
            let data = new FormData();
            data.append('file', this.form.file, filename);
            data.append('operation', this.form.operation);
            data.append('type', this.form.type);
            if (this.isMember === 'member') data.append('autoFixPhone', this.form.autoFixPhone);
            // 链接判断
            let request;
            if (this.isMember === 'member') request = API.post('import/client', data);
            else request = API.post('import/contract', data);
            // 导入
            request.then(() => {
                this.$router.push({
                    name: 'Setting.List',
                    query: {
                        activeName: 'fifth',
                    },
                });
            });
        },
    },
};
</script>

<style lang="scss">
.upload {
    font-size: 12px;
    .upload-tips-red {
        color: #db093f;
    }
    ul, li {
        list-style: none;
        padding: 0;
    }
    h4 {
        font-size: 14px;
        margin: 0;
    }
    .import-types {
        margin: 50px auto;
        overflow: hidden;
        li {
            text-align: center;
            width: 300px;
            i {
                overflow: hidden;
                position: relative;
                display: block;
                cursor: pointer;
                width: 207px;
                height: 215px;
                margin: 0 auto 15px;
                border: 2px solid #d2d2d2;
                border-radius: 5px;
                box-sizing: border-box;
                &::before {
                    content: '';
                    display: block;
                    margin: 58px auto 0;
                    background: url(../assets/images/import_types.png) left top no-repeat;
                }
            }
            &:nth-child(1) i::before {
                width: 91px;
                height: 99px;
                background-position: 0 0;
            }
            &:nth-child(2) i::before {
                width: 83px;
                height: 91px;
                background-position: -100px 0;
            }
            &:nth-child(3) i::before {
                width: 83px;
                height: 91px;
                background-position: -200px 0;
            }
            &.active {
                i {
                    border-color: #05abef;
                    border-radius: 5px;
                }
                i::after {
                    content: '';
                    display: block;
                    position: absolute;
                    width: 33px;
                    height: 29px;
                    right: 0;
                    top: 0;
                    background: url(../assets/images/import_current.png) left top no-repeat;
                    background-size: 33px;
                }
            }
        }
        li:nth-child(1).active i::before {
            background-position: 0 -100px;
        }
        li:nth-child(2).active i::before {
            background-position: -100px -100px;
        }
        li:nth-child(3).active i::before {
            background-position: -200px -100px;
        }
        p {
            color: gray;
            line-height: 1.5;
            b {
                font-size: 14px;
                color: #666;
                line-height: 2;
            }
        }
    }
}
</style>
